import React, {Component} from 'react';
import {RaisedButton, TextField, Dialog, FlatButton, SvgIcon} from 'material-ui';
import {hideSpinner} from 'utils/spinner';
import tinycolor from 'tinycolor2';
import _ from 'lodash';

const styles = {
    form: {
        width: '80%',
        position: 'absolute',
        top: '0',
        left: '50%',
        transform: 'translate(-50%, 0)',
        paddingTop: '50px'
    },
    checkbox: {
        marginBottom: 16,
        marginTop: 16,
    },
    label: {
        color: 'white',
        fontWeight: 400
    },
    underline: {
        bottom: 0
    },
    signInButton: {
        width: '100%'
    },
    socialButton: {
        width: '40%'
    },
    buttons: {
        width: '100%',
        margin: '20px auto'
    },
    social: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 20
    },
    header: {
       container: {
           display: 'flex',
           flexDirection: 'column'
       },
       flex: {
           display: 'flex',
       },
       spanWrapper: {
          marginTop: '40.5px',
          marginBottom: '70px',
          display: 'flex',
          flexDirection: 'column'
       },
       spanFirst: {
         color: '#4a4a4a',
         fontSize: '41px',
         fontWeight: 900
       },
       spanSecond: {
            color: '#4a4a4a',
            fontSize: '41px',
            fontWeight: 300
       },
       spanBeta: {
            color: '#9b9b9b',
            fontSize: '11px',
            fontWeight: 400,
            marginLeft: '5px'
       },
       desc: {
           color: '#4a4a4a',
           fontWeight: '400',
           fontSize: '18px'
       },
       descBottom: {
            color: '#4a4a4a',
            fontWeight: '400',
            fontSize: '18px',
            marginTop: '22.5px'
       },
       href: {
           color: '#1497f1',
           fontWeight: '400',
           fontSize: '18px',
           marginLeft: '5px',
           textDecoration: 'none'
       },
        imgLogo: {
            margin: '0 auto',
            width: '110px',
            display: 'block',
            marginBottom: '38.5px'
        }
    }
};

class LoginForm extends Component {
    // Using "Stateless Functional Components"

    constructor(props) {
        super(props);
        this.state = {
            showModal: !_.isEmpty(this.props.loginError)
        };

        // window.props = props;
        // window.state = this.state;
    }

    handleClose() {
        this.setState({
            showModal: false
        })
    };

    componentWillReceiveProps(nextProps){
        if (!this.state.showModal && !_.isEmpty(nextProps.loginError)){
            this.setState({
                showModal: true
            })
        }
    }

    componentDidMount(){
        hideSpinner();
    }

    getErrorMessage() {
        if (_.isEmpty(this.props.loginError)) {
            return;
        }
        return this.props.loginError.message;

    }

    render() {

        const actions = [<FlatButton label="OK" primary={true} onTouchTap={this.handleClose.bind(this)}/>];

        const facebookIcon =  <SvgIcon color="white" viewBox="0 0 16 28"><path d="M14.984 0.187v4.125h-2.453c-1.922 0-2.281 0.922-2.281 2.25v2.953h4.578l-0.609 4.625h-3.969v11.859h-4.781v-11.859h-3.984v-4.625h3.984v-3.406c0-3.953 2.422-6.109 5.953-6.109 1.687 0 3.141 0.125 3.563 0.187z"/></SvgIcon>;
        const googleIcon =  <SvgIcon color="white" viewBox="0 0 24 28"><path d="M12 12.281h11.328c0.109 0.609 0.187 1.203 0.187 2 0 6.844-4.594 11.719-11.516 11.719-6.641 0-12-5.359-12-12s5.359-12 12-12c3.234 0 5.953 1.188 8.047 3.141l-3.266 3.141c-0.891-0.859-2.453-1.859-4.781-1.859-4.094 0-7.438 3.391-7.438 7.578s3.344 7.578 7.438 7.578c4.75 0 6.531-3.406 6.813-5.172h-6.813v-4.125z"/>
        </SvgIcon>;

        const facebookColor = '#3b5998';
        const facebookColorHover = tinycolor(facebookColor).lighten(20).toHexString();
        const googleColor = '#dc4a38';
        const googleColorHover = tinycolor(googleColor).lighten(20).toHexString();

        return <div className="login-form" style={styles.form}>
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.showModal}
                onRequestClose={this.handleClose}>
                {this.getErrorMessage()}
            </Dialog>
            <div style={styles.header.container}>
                <img style={styles.header.imgLogo} alt="logo" src="images/logo-wochit.svg" />
                <div style={styles.header.flex}>
                    <span style={styles.header.spanFirst}>MoJo</span>
                    <span style={styles.header.spanSecond}>Uploader</span>
                    <span style={styles.header.spanBeta} >BETA</span>
                </div>
                <div style={styles.header.spanWrapper}>
                    <span style={styles.header.desc}>Instantly upload videos and images directly into your production line. Wochit customers, log in to start.</span>
                    <span style={styles.header.descBottom} >For help, <a style={styles.header.href} href="https://www.wochit.com/article/wochit-mojo-uploader" target="_blank">click here</a>.</span>
                </div>
            </div>
            <form onSubmit={this.props.login} ref={(form => this.formEl = form)}>
                <TextField type="email" name="email" hintText="Email" required fullWidth={true} underlineStyle={styles.underline}/>
                <TextField type="password" name="password" hintText="Password" fullWidth={true} underlineStyle={styles.underline}/>

                <div style={styles.buttons}>
                    <div><RaisedButton style={styles.signInButton} primary={true} label='Sign In' type="submit"/></div>
                    <div style={styles.social}>
                        {/*<FlatButton backgroundColor={facebookColor}  hoverColor={facebookColorHover}*/}
                                    {/*icon={facebookIcon} label="SIGN IN" labelStyle={styles.label} style={styles.socialButton}*/}
                                    {/*labelPosition="after" onClick={this.props.loginWithFacebook}>*/}
                        {/*</FlatButton>*/}
                        {/*<small>OR</small>*/}
                        <FlatButton backgroundColor={googleColor}  hoverColor={googleColorHover}
                                    icon={googleIcon} label="SIGN IN" labelStyle={styles.label} style={styles.signInButton}
                                    labelPosition="after" onClick={this.props.loginWithGoogle}>
                        </FlatButton>

                    </div>
                </div>
            </form>
        </div>;
    }
}

export default LoginForm;
